import React from 'react';
import { ExternalLink, BookOpen } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

const References = () => {
  const references = [
    {
      title: 'New Zealand Low-Risk Alcohol Drinking Advice',
      organization: 'Alcohol.org.nz',
      url: 'https://www.alcohol.org.nz/help-advice/advice-on-alcohol/low-risk-alcohol-drinking-advice',
      description: 'Official guidance on low-risk alcohol consumption in New Zealand'
    },
    {
      title: 'Alcohol and Pregnancy',
      organization: 'Alcohol.org.nz',
      url: 'https://www.alcohol.org.nz/help-advice/advice-on-alcohol/alcohol-pregnancy',
      description: 'Information about alcohol use during pregnancy'
    },
    {
      title: 'What is a Standard Drink?',
      organization: 'Alcohol.org.nz',
      url: 'https://www.alcohol.org.nz/help-advice/advice-on-alcohol/low-risk-alcohol-drinking-advice',
      description: 'Understanding what constitutes a standard drink in New Zealand'
    },
    {
      title: 'Alcohol Drug Helpline',
      organization: 'Alcohol Drug Helpline',
      url: 'https://alcoholdrughelp.org.nz/',
      description: 'Free, confidential support for alcohol and drug issues'
    },
    {
      title: 'Talking to Young People About Alcohol',
      organization: 'Alcohol.org.nz',
      url: 'https://www.alcohol.org.nz/help-advice/advice-on-alcohol/talking-to-young-people-about-alcohol',
      description: 'Resources for parents and caregivers'
    },
  ];

  return (
    <Card className="bg-gradient-to-br from-blue-50 to-indigo-50 border-blue-200">
      <CardHeader>
        <CardTitle className="flex items-center text-xl">
          <BookOpen className="mr-3 h-6 w-6 text-blue-600" />
          References & Further Information
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-gray-700 mb-4">
          Our information is based on evidence from trusted New Zealand health organizations:
        </p>
        <div className="space-y-3">
          {references.map((ref, index) => (
            <a
              key={index}
              href={ref.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-white p-4 rounded-lg hover:shadow-md transition-all duration-200 group"
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h4 className="font-bold text-gray-900 group-hover:text-blue-600 transition-colors">
                    {ref.title}
                  </h4>
                  <p className="text-sm text-gray-600 mb-1">{ref.organization}</p>
                  <p className="text-sm text-gray-500">{ref.description}</p>
                </div>
                <ExternalLink className="h-5 w-5 text-blue-600 ml-2 flex-shrink-0 group-hover:scale-110 transition-transform" />
              </div>
            </a>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default References;